import React from 'react'
import { MessageSquare } from 'lucide-react'
import { Button } from '@/components/ui/button'

class SmsButton extends React.Component {

  onClick = () => {
    this.props.store.emit('ui:lead:smser:toggle')
  }

  render() {
    return (
      <Button size="sm" variant="secondary" title="Send SMS" onClick={this.onClick}><MessageSquare className="size-4" /></Button>
    )
  }
}

export default SmsButton
